module.exports = __webpack_public_path__ + "media/images/search-button-ffc47c79d65fda7f764e7e2a37841295.png";